"use client";

/**
 * Запись состояния таблицы в адресную строку. Проект подставляет свою реализацию под роутер;
 * чтение состояния при открытии страницы остаётся в коде страниц.
 */
export interface TableUrlAdapter {
  /** Текущая строка запроса вместе с `?` (или пустая строка). */
  getSearch(): string;
  /** Заменить строку запроса без новой записи в истории. */
  replaceSearch(search: string): void;
}

/** Реализация по умолчанию: `window.location` и `window.history.replaceState`. */
export const defaultTableUrlAdapter: TableUrlAdapter = {
  getSearch: () => window.location.search,
  replaceSearch: (search) => {
    window.history.replaceState(null, "", `${window.location.pathname}${search}`);
  },
};
